const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class Frugality extends Action {
    constructor(age){
        super(
            age,
            ActionNames.Frugality,
            `Increase your population. After you pay the food cost, gain ${Frugality.GetFoodAmount(age)} food.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetFoodAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 1;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
        }
    }
}

module.exports = Frugality;
